<style scoped lang="scss">
.gk-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.gk-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.gk-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.gk-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

.gy-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.gy-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.gy-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.gy-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

.tj-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.tj-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.tj-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.tj-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

.dialog /deep/ .el-dialog__body {
  overflow: auto;
}
.left {
  display: flex;
  align-items: center;

  .icon {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #419fff;
  }

  .txt {
    display: inline-block;
    font-weight: 400;
    font-size: 16px;
    color: #303133;
    margin-left: 12px;
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/wo_debug_guide" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="yt.conditions.equipmentId">-->
            <!--						</yi_cross_select>-->
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'"-->
            <!--							:ids.sync="yt.conditions.materialId">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button @click="handleParam(scope.row)" type="text" size="small">
              {{ $t('chakangongyitiaojizhiyin') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>
				</el-button>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
    </yi_curd_table>
    <!-- 工艺参数dialog -->
    <el-dialog class="dialog" :title="$t(param.title)" :visible.sync="param.visible" :width="param.width" destroy-on-close @close="close">
      <div id="export">
        <div>
          <el-descriptions :column="3" :colon="false">
            <el-descriptions-item :label="$t('shebeimingcheng')">{{ equipmentName }}</el-descriptions-item>
            <el-descriptions-item :label="$t('mojubianhao/mingcheng')">{{ mouldNo }}/{{ mouldName }}</el-descriptions-item>
            <el-descriptions-item :label="$t('chanpingbianma/mingcheng')">{{ materialCode }}/{{ materialName }}</el-descriptions-item>
            <!-- <el-descriptions-item label="生产时间">{{dialogTime}}</el-descriptions-item> -->
          </el-descriptions>
        </div>
        <div style="display: flex;flex-wrap: nowrap;align-items: center;">
          <div class="left">
            <span class="icon" />
            <!-- <span class="txt">{{$t('zinjinlianxuwendingshangchan')}}</span> -->
            <div class="txt" style="display: flex;flex-wrap: nowrap;align-items: center;">
              <!-- 	<yi_dictionary_select @change="changgeName" :type="'DEBUG_GUIDE_OPTIONS'" :ids.sync="count">
									</yi_dictionary_select> -->
              <div>{{ $t('zuijinlianxuwendingshengchan') }}</div>
              <div style="margin-top: -1px;margin-left: 5px;">
                <el-select size="mini" v-model="count" @change="changgeName">
                  <el-option :label="20" :value="20"></el-option>
                  <el-option :label="50" :value="50"></el-option>
                  <el-option :label="100" :value="100"></el-option>
                  <el-option :label="200" :value="200"></el-option>
                  <el-option :label="300" :value="300"></el-option>
                </el-select>
              </div>
              <div style="margin-left: 5px;">{{ $t('mogongyituijian') }}</div>
            </div>
          </div>
        </div>
        <div class="gy-html" v-html="gy"></div>
      </div>
      <div slot="footer">
        <div>
          <el-button size="mini" type="default" plain @click="param.visible = false">{{ $t('quxiao') }} </el-button>
          <el-button size="mini" type="primary" @click="exportPic">{{ $t('daochutupian') }} </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_process_management_tuning_guide_list',

  data() {
    return {
      currentRow: {},
      list: [],
      count: 20,
      eqId: '',
      param: {
        title: 'chakangongyitiaojizhiyin',
        visible: false,
        width: '88%'
      },
      gkHtml: '',
      gyHtml: '',
      tjHtml: '',
      key: 0,
      dialogTime: '',
      singleMonitorData: '', //点
      equipmentName: '',
      mouldNo: '',
      mouldName: '',
      materialName: '',
      materialCode: '',
      info: {},
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mouldNo',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mouldName',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'tag',
          tags: {
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            }
          }
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    this.yt.editObj.count = 20;
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'sort asc'
      };
      this.yt.get(1);
    }, 300);
  },
  computed: {
    gy() {
      // console.log('qqqq', this.eqId)
      console.log('this.eqPointId', this.store.state.eqPoints[this.eqId]);
      let str = this.gyHtml;
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map(code => {
          let c = code.replace('[', '');
          c = c.replace(']', '');
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map(code => {
          let c = code.replace('{', '');
          c = c.replace('}', '');

          if (!this.store.state.eqPoints[this.eqId][c]) {
            console.log(this.$t('gongyimobanqueshaodian') + ':' + c);
            // this.utils.errorMessage(this.$t('gongyimobanqueshaodian') + ':' + c)
            return;
          }
          console.log('ggggggggggggggggg', this.store.state.eqPoints[this.eqId][c].dictTypeCode);

          if (this.store.state.eqPoints[this.eqId][c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.store.state.eqPoints[this.eqId][c].dictTypeCode][parseInt(this.tabsData.eqPoints[c])]));
          } else if (!this.store.state.eqPoints[this.eqId][c].formula) {
            if (c == '361') {
              console.log('this.singleMonitorData', this.singleMonitorData);
            }
            str = str.replace(code, isNaN(Number(this.singleMonitorData[c]).toFixed(2)) ? '' : Number(this.singleMonitorData[c]).toFixed(2));
          } else {
            let formula = this.store.state.eqPoints[this.eqId][c].formula;
            let reg3 = /\{[^\}]*\}/g;
            formula.match(reg3) &&
              formula.match(reg3).map(code2 => {
                let c2 = code2.replace('{', '');
                c2 = c2.replace('}', '');

                formula = formula.replace(code2, this.singleMonitorData[c2]);
              });
            str = str.replace(code, (execMathExpress(formula).num / execMathExpress(formula).den).toFixed(2));
          }
        });
      return str;
    }
  },
  methods: {
    // 导出图片
    exportPic() {
      html2canvas(document.getElementById('export')).then(canvas => {
        let dataURL = canvas.toDataURL('image/png');
        if (dataURL !== '') {
          var a = document.createElement('a');
          a.download = this.$t('gongyicanshu');
          a.href = dataURL;
          a.click();
        }
      });
    },
    close() {
      this.count = 20;
    },
    changgeName(e) {
      this.handleParam(this.currentRow);
    },
    handleParam(row) {
      this.currentRow = row;
      this.equipmentName = row.equipmentName;
      this.mouldNo = row.mouldNo;
      this.mouldName = row.mouldName;
      this.materialName = row.materialName;
      this.materialCode = row.materialCode;
      this.eqId = row.equipmentId;
      let params = {
        equipmentId: row.equipmentId,
        woId: row.woId,
        count: this.count
      };
      this.gyHtml = '';

      return this.http.get('/web/wo/debug/guide/details?' + this.qs.stringify(params)).then(response => {
        if (response.data == undefined) {
          this.utils.errorMessage(this.$t('qingpeizhimuban'));
        }
        console.log('response', response.data.table.gy);
        if (response.data !== undefined) {
          this.singleMonitorData = response.data.singleMonitorData;
          this.gyHtml = response.data.table.gy;
          this.gyHtml = this.base64.decode(this.gyHtml);
          this.partNo = response.data.currentMaterialNo;
          this.param.visible = true;
        }
        console.log('response11', this.gyHtml);
      });
    }
  }
};
</script>
